
<ng-container *ngIf="schema | async as _schema; else loading">


  <h4>Eve Data Source</h4>

  <mat-grid-list cols="4" rowHeight="150px" [gutterSize]="'10px'">

    <mat-grid-tile [style.background-color]="dataSource.queryField == 'telepoCdrsPage' ? '#00abca' : '#ededed'">
      <button class="widget-type-button" (click)="dataSource.queryField = 'telepoCdrsPage'">
        <div>
          <div>
            <mat-icon class="mat-icon-widget-type-button">call</mat-icon>
          </div>
          <p style="margin-top:0;">Calls Data 1: telepoCdrsPage</p>
        </div>
      </button>
    </mat-grid-tile>

    <mat-grid-tile [style.background-color]="dataSource.queryField == 'eveCdrsPage' ? '#00abca' : '#ededed'">
      <button class="widget-type-button" (click)="dataSource.queryField = 'eveCdrsPage'">
        <div>
          <div>
            <mat-icon class="mat-icon-widget-type-button">support_agent</mat-icon>
          </div>
          <p style="margin-top:0;">Calls Data 2: eveCdrsPage</p>
        </div>
      </button>
    </mat-grid-tile>

    <mat-grid-tile [style.background-color]="dataSource.queryField == 'telepoGroupStatsPage' ? '#00abca' : '#ededed'">
      <button class="widget-type-button" (click)="dataSource.queryField = 'telepoGroupStatsPage'">
        <div>
          <div>
            <mat-icon class="mat-icon-widget-type-button">phone_forwarded</mat-icon>
          </div>
          <p style="margin-top:0;">Call Queue Stats Data: telepoGroupStatsPage</p>
        </div>
      </button>
    </mat-grid-tile>

    <mat-grid-tile [style.background-color]="dataSource.queryField == 'telepoGroupEveUserStatsPage' ? '#00abca' : '#ededed'">
      <button class="widget-type-button" (click)="dataSource.queryField = 'telepoGroupEveUserStatsPage'">
        <div>
          <div>
            <mat-icon class="mat-icon-widget-type-button">groups</mat-icon>
          </div>
          <p style="margin-top:0;">Call Queue User Stats Data: telepoGroupEveUserStatsPage</p>
        </div>
      </button>
    </mat-grid-tile>
  </mat-grid-list>





  <ng-container *ngIf="dataSource.queryField != null">
    <div style="display: flex;">
      <h4 style="flex: 1 1 auto;">Selects</h4>
    </div>

    <mat-form-field appearance="fill" style="width:100%;">
      <mat-label>Value</mat-label>
      <mat-select [(value)]="dataSource.value">
        <mat-option>None</mat-option>
        <mat-option *ngFor="let field of getSelectFields(_schema)" [value]="field.name">{{field.name}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" style="width:100%;">
      <mat-label>Legend</mat-label>
      <mat-select [(value)]="dataSource.legend">
        <mat-option>None</mat-option>
        <mat-option *ngFor="let field of getSelectFields(_schema)" [value]="field.name">{{field.name}}</mat-option>
      </mat-select>
    </mat-form-field>

    <!--<mat-grid-list cols="4" rowHeight="150px" [gutterSize]="'10px'">
    <mat-grid-tile *ngFor="let field of getSelectFields(_schema)" [style.background-color]="dataSource.selects.field == field.name ? '#00abca' : '#ededed'">
      <button class="widget-type-button" (click)="dataSource.selects.field = field.name">
        <div>
          <div>
            <mat-icon *ngIf="field.name == 'eveCdrSourceId'" class="mat-icon-widget-type-button">raw_on</mat-icon>
            <mat-icon *ngIf="field.name == 'companyOrganisationId'" class="mat-icon-widget-type-button">apartment</mat-icon>
            <mat-icon *ngIf="field.name == 'messageTypeWeight'" class="mat-icon-widget-type-button">sentiment_dissatisfied</mat-icon>
            <mat-icon *ngIf="field.name == 'duration'" class="mat-icon-widget-type-button">timer</mat-icon>
            <mat-icon *ngIf="field.name == 'result'" class="mat-icon-widget-type-button">check_circle</mat-icon>
            <mat-icon *ngIf="field.name == 'count'" class="mat-icon-widget-type-button">123</mat-icon>
            <mat-icon *ngIf="field.name == 'sourceMOS'" class="mat-icon-widget-type-button">local_fire_department</mat-icon>
            <mat-icon *ngIf="field.name == 'sourceRFactor'" class="mat-icon-widget-type-button">celebration</mat-icon>
            <mat-icon *ngIf="field.name == 'sourceAvgLatency'" class="mat-icon-widget-type-button">attractions</mat-icon>
            <mat-icon *ngIf="field.name == 'sourceMaxLatency'" class="mat-icon-widget-type-button">brightness_high</mat-icon>
            <mat-icon *ngIf="field.name == 'sourcePacketsLost'" class="mat-icon-widget-type-button">accessibility</mat-icon>
            <mat-icon *ngIf="field.name == 'sourceAvgJitter'" class="mat-icon-widget-type-button">handshake</mat-icon>
            <mat-icon *ngIf="field.name == 'sourceMaxJitter'" class="mat-icon-widget-type-button">waving_hand</mat-icon>
            <mat-icon *ngIf="field.name == 'targetMOS'" class="mat-icon-widget-type-button">ads_click</mat-icon>
            <mat-icon *ngIf="field.name == 'targetRFactor'" class="mat-icon-widget-type-button">factory</mat-icon>
            <mat-icon *ngIf="field.name == 'targetAvgLatency'" class="mat-icon-widget-type-button">currency_bitcoin</mat-icon>
            <mat-icon *ngIf="field.name == 'targetMaxLatency'" class="mat-icon-widget-type-button">assignment_late</mat-icon>
            <mat-icon *ngIf="field.name == 'targetPacketsLost'" class="mat-icon-widget-type-button">wc</mat-icon>
            <mat-icon *ngIf="field.name == 'targetAvgJitter'" class="mat-icon-widget-type-button">flaky</mat-icon>
            <mat-icon *ngIf="field.name == 'targetMaxJitter'" class="mat-icon-widget-type-button">sentiment_satisfied</mat-icon>
          </div>
          <p style="margin-top: 0; word-wrap: break-word;">{{field.name}}</p>
        </div>
      </button>
    </mat-grid-tile>
  </mat-grid-list>-->

    <div style="display: flex;">
      <h4 style="flex: 1 1 auto;">Wheres</h4>

      <button mat-raised-button color="primary" aria-label="Add a new select" (click)="onAddWhereClick()" style="text-align: right; margin: auto 0;">
        <mat-icon>add</mat-icon> New Where
      </button>
    </div>

    <div *ngFor="let where of dataSource.wheres;let whereIndex=index;" style="display: flex; background-color: #b6b6b6; box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;">
      <div style="flex: 1 1 auto; margin: 10px; flex-basis: 30%">
        <mat-form-field appearance="fill" style="width:100%;">
          <mat-label>Where</mat-label>
          <mat-select [name]="'where[' +index +'].path'" [(ngModel)]="where.path">
            <mat-option>None</mat-option>
            <mat-option *ngFor="let field of getReturnFields(_schema)" [value]="field.name">{{field.name}}</mat-option>

          </mat-select>
        </mat-form-field>
      </div>


      <ng-container *ngIf="getFieldType(_schema, where.path) as _fieldType">
        <div style="flex: 1 1 auto; margin: auto 10px; text-align: center; flex-basis: 30%">
          <div *ngIf="where.path != null">
            <div style="display: flex; flex-direction: column">
              <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Comparison</mat-label>
                <mat-select [name]="'where[' +index +'].comparison'" [(ngModel)]="where.comparison">
                  <mat-option>None</mat-option>
                  <mat-option *ngFor="let graphQLComparision of getComparisons(_fieldType)" [value]="graphQLComparision">{{graphQLComparision | graphQLComparisionAsString}}</mat-option>

                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div style="flex: 1 1 auto; margin: 10px; text-align: center; flex-basis: 30%">
          <div *ngIf="where.path != null">

            <mat-slide-toggle [(ngModel)]="where.isControlWidget">Use Control Value</mat-slide-toggle>

            <div *ngIf="!where.isControlWidget">
              <!--<p>{{where.path.type.ofType.name | json}}</p>-->
              <p>{{where.path.type | json }}</p>

              <div *ngIf="_fieldType.type.name  == 'String' || _fieldType.type.ofType?.name == 'String'">
                <mat-form-field appearance="fill" style="width:100%;">
                  <mat-label>Value</mat-label>
                  <input [name]="'where[' +index +'].value'" [(ngModel)]="where.value" matInput>
                </mat-form-field>
              </div>
              <div *ngIf="(_fieldType.type.name  == 'Int' || _fieldType.type.ofType?.name == 'Int') || (_fieldType.type.name  == 'Long' || _fieldType.type.ofType?.name == 'Long')">
                <mat-form-field appearance="fill" style="width:100%;">
                  <mat-label style="flex: 1 1 auto;">Value</mat-label>
                  <input [name]="'where[' +index +'].value'" [(ngModel)]="where.value" type="number" matInput style="flex: 1 1 auto;">
                </mat-form-field>
              </div>

              <div *ngIf="_fieldType.type.name  == 'DateTimeOffset' || _fieldType.type.ofType?.name == 'DateTimeOffset'">
                <mat-form-field appearance="fill" style="width:100%;">
                  <mat-label style="flex: 1 1 auto;">Value</mat-label>
                  <input [name]="'where[' +index +'].value'" [(ngModel)]="where.value" type="datetime-local" matInput style="flex: 1 1 auto;">
                </mat-form-field>
              </div>

              <div *ngIf="_fieldType.type.name  == 'Boolean' || _fieldType.type.ofType?.name == 'Boolean'">
                <mat-form-field appearance="fill" style="width:100%;">
                  <mat-label>Select a Value</mat-label>
                  <mat-select [name]="'where[' +index +'].value'" [(ngModel)]="where.value">
                    <mat-option>None</mat-option>
                    <mat-option value="True">True</mat-option>
                    <mat-option value="False">False</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div *ngIf="where.isControlWidget">


              <div style="display: flex; flex-direction: column">
                <mat-form-field appearance="fill" style="width:100%;">
                  <mat-label>Control</mat-label>
                  <mat-select [name]="'where[' +index +'].value'" [(ngModel)]="where.value">
                    <mat-option>None</mat-option>
                    <mat-option *ngFor="let control of (controlWidgetService.controlWidgets | async )" [value]="control.widget.controlWidgetId">{{control.widget.controlWidgetName}} {{control.controlValue | async}}</mat-option>

                  </mat-select>
                </mat-form-field>
              </div>

            </div>

            <!--<div *ngFor="let control of (controlWidgetService.controlWidgets | async )">
              {{control.widget.controlWidgetName}} {{control.controlValue | async}}
            </div>-->

            <div *ngFor="let control of (controlWidgetService.controlWidgets | async )">
              {{control.widget.controlWidgetId}} {{control.controlValue | async}}
            </div>
          </div>
        </div>

      </ng-container>






      <div style="flex: 1 1 auto; margin: auto; text-align: center; flex-basis: 10%">
        <button mat-icon-button color="warn" aria-label="Remove Where" (click)="dataSource.wheres.splice(whereIndex,1)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>

    </div>
  </ng-container>

</ng-container>

<ng-template #loading>
  Loading.....
</ng-template>
